module.exports = __webpack_public_path__ + "static/media/orderListing.c4b58391.png";